import styled from 'styled-components';
import { mainColor, mainFont } from '../../styles/global';

//  LeftSection, RightColSection, SavingsHeader, SavingsWrapper

export const InvestmentColTwoSpanReverse = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    gap:10rem;
    height:fit-content;
    @media screen and (max-width: 768px) {
        flex-direction: column-reverse;
        gap:2rem;
        height:fit-content;
    }
`;


export const RightColSection = styled.div`
    background:#D9F3F3;
    border-radius:4px;
    flex:0.4;
    margin-top:80px;
    img{
        height:90%;
        width:90%;
    }
    @media screen and (max-width: 768px) {
        display:flex;
        justify-content: center;
        align-items: center;
        img{
            height:80%;
            width:80%;
        }
    }
`;
export const  LeftColSection = styled.div`
    flex:0.55;
    h3{
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 26px;
        line-height: 55px;
        letter-spacing: 0.01em;
        color: #090458;
        color:${mainColor};
        // margin-bottom:60px;
    }
    @media screen and (max-width: 768px) {
        h3{
            font-weight: 500;
            font-size: 27px;
            line-height: 33px;
            font-size: 13.2468px;
        }
    }

`;

